import { ReactNode } from "react";

interface Props<T> {
  readonly dataItem: T;
  readonly commands?: (dataItem: T) => ReactNode[];
}

export default function CommandCell<T>({ dataItem, commands }: Props<T>) {
  return <td className="k-command-cell">{commands && commands(dataItem)}</td>;
}
